export const SubscriptionCodeToLearnMoreUrl: { [id: string]: string } = {
    'TRIAL-ANL': 'https://www.uipath.com/product/rpa-insights',
    'TRIAL-AHUB': 'https://www.uipath.com/product/automation-hub',
    'TRIAL-PM': 'https://www.uipath.com/product/process-mining',
    'TRIAL-RU': 'https://www.uipath.com/product/automation-cloud-robots',
    'TRIAL-AGU': 'https://www.uipath.com/platform/agentic-automation',
    'TRIAL-HEAL': 'https://docs.uipath.com/agents/automation-cloud/latest/user-guide-ha/what-is-healing-agent',
    'TRIAL-SPR': 'https://docs.uipath.com/agents/automation-cloud/latest/user-guide-screenplay/licensing',
};
